import { Injectable } from '@angular/core';
import { DisclaimerType, M1Disclaimer } from '@m1/components';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DisclaimerService {
  private _disclaimerSource = new Subject<M1Disclaimer>();
  disclaimer$ = this._disclaimerSource.asObservable();

  constructor(private translate: TranslateService) {}

  /** Send a translated disclaimer */
  sendTranslatedDisclaimer(type: DisclaimerType, translationKey: string) {
    const text = this.translate.instant(translationKey);
    const disclaimer: M1Disclaimer = {
      type,
      text,
      shouldTimeout: false,
    };
    this._disclaimerSource.next(disclaimer);
  }

  /** Send a custom disclaimer (static text) */
  sendDisclaimer(disclaimer: M1Disclaimer) {
    this._disclaimerSource.next(disclaimer);
  }
}
